import { render } from "./NewModal.vue?vue&type=template&id=3e8eaa7a"
import script from "./NewModal.vue?vue&type=script&lang=js"
export * from "./NewModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__